import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const featuredArticles = articles.filter((a) => a.isFeatured);

export default function ArticleGrid() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="mb-10">
        <h2 className="text-3xl md:text-5xl font-black font-heading text-foreground-950 mb-2">
          每日必吃精选
        </h2>
        <p className="text-foreground-500 text-sm">
          每日更新黑料爆料与热门吃瓜事件，不错过任何一条重磅八卦
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {featuredArticles.map((article, idx) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group block rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 overflow-hidden cursor-pointer"
          >
            {/* Image */}
            <div className="relative h-52 md:h-60 overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              {idx === 0 && (
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-bold">
                  热门
                </div>
              )}
              <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-black/50 text-white text-xs">
                {article.views >= 100000
                  ? `${Math.floor(article.views / 10000)}万浏览`
                  : `${article.views}浏览`}
              </div>
            </div>
            {/* Content */}
            <div className="p-5 text-center">
              <h3 className="text-base md:text-lg font-bold font-heading text-foreground-950 group-hover:text-primary-500 transition-colors mb-3 line-clamp-2">
                {article.title}
              </h3>
              <div className="flex items-center justify-center gap-3 text-xs text-foreground-500 mb-4">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.views >= 10000
                    ? `${Math.floor(article.views / 10000)}万`
                    : article.views}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line"></i>
                  {article.comments}
                </span>
                <span>{article.date}</span>
              </div>
              <span
                className={`inline-block w-4/5 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
                  idx === 0
                    ? 'bg-primary-500 text-white group-hover:bg-primary-600'
                    : 'border border-foreground-300 text-foreground-700 group-hover:border-primary-500 group-hover:text-primary-500'
                }`}
              >
                {idx === 0 ? '查看详情' : '阅读全文'}
              </span>
              <p className="text-[10px] text-foreground-400 mt-3">
                内容仅供参考，不构成事实认定
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}